import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { atom, useRecoilState, useRecoilValue } from "recoil";
import { GetSubscriptionSetData } from "../../../../../Api/ServiceDatas";
import { useApi } from "../../../../../hooks/useApi";
import { authType } from "../../../../../pages/Login";
import LineBtn from "../../../../Button/LineBtn";
import LineBox from "../../../../DefaultStyles/LineBox";
import Loader from "../../../../DefaultStyles/Loader";
import Pagination from "../../../../Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../../../Table/Table";
import { ChatSection, ChatSectionTitle } from "../ChatSearch/ChatSearchResult";
import ChatReportDetailModal from "./ChatReportDetailModal/ChatReportDetailModal";
import { toast } from "react-toastify";
import { reportReasonList } from "./ChatReport";
import { isNewChat } from "../../../../../pages/Party/ChatInfo";
import { getSubsNameBySubsId3 } from "../../../../../AdminApi/3.0_utils";

export interface IChatReportComplete {
  id: string;
  msgList: string[];
  uid: {
    name: string;
    nickname: string;
    uid: string;
  };
  user: {
    name: string;
    nickname: string;
    uid: string;
  };
  party: {
    partyid: string;
    servsubsid: number;
    ownerid: string;
  };
  reason: string;
  reasonid: number;
  target: {
    uid: string;
    name: string;
    nickname: string;
  };
  time: string;
  comptime: string;
  comment: string;
  admin: string;
  adminId: string;
}

export const reportCompleteListState = atom<IChatReportComplete[]>({
  key: "reportCompleteListState",
  default: [],
});

export default function ReportComplete() {
  const auth = useRecoilValue(authType);
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [reportCompleteList, setReportCompleteList] = useRecoilState(
    reportCompleteListState
  );
  const [reportDetailModal, setReportDetailModal] = useState(false);
  const [detailData, setDetailData] = useState<IChatReportComplete>({
    id: "",
    msgList: [],
    user: {
      name: "",
      nickname: "",
      uid: "",
    },
    uid: {
      name: "",
      nickname: "",
      uid: "",
    },
    party: {
      partyid: "",
      servsubsid: 0,
      ownerid: "",
    },
    reason: "",
    reasonid: 0,
    target: {
      uid: "",
      name: "",
      nickname: "",
    },
    time: "",
    comptime: "",
    comment: "",
    admin: "",
    adminId: "",
  });

  const { response, loading, error } = useApi({
    method: "get",
    url: auth?.chat
      ? `${isNewChat ? "chat" : "oldchat"}/report?state=1&page=${page}&size=5`
      : undefined,
  });

  console.log(response);

  const reportCompleteTableHead = [
    "신고자",
    "PID",
    "Subscription",
    "사유 구분",
    "신고 일시",
    "처리 완료 일시",
    "보기",
  ];

  useEffect(() => {
    if (response?.status === 200 && response?.data?.items?.length > 0) {
      setReportCompleteList(response?.data?.items?.reverse());
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(
        error?.data ?? "채팅 신고 처리 완료 내역 조회에 실패하였습니다."
      );
    }
  }, [error]);

  return (
    <ChatSection>
      <ChatSectionTitle>신고 처리 완료</ChatSectionTitle>

      <LineBox>
        <Table tableHeadData={reportCompleteTableHead}>
          <>
            {reportCompleteList?.map(
              (d: IChatReportComplete, index: number) => {
                return (
                  <TableBody key={index}>
                    <TableBodyItem
                      clickable={true}
                      onClick={() => navigate(`/users/info/${d?.user?.uid}`)}
                    >
                      {d?.user?.uid}_{d?.user?.name}_{d?.user?.nickname}
                    </TableBodyItem>
                    <TableBodyItem
                      clickable={true}
                      onClick={() =>
                        navigate(`/party/info/${d?.party?.partyid}`)
                      }
                    >
                      {d?.party?.partyid}
                    </TableBodyItem>
                    <TableBodyItem>
                      {d?.party?.servsubsid}_
                      {getSubsNameBySubsId3(d?.party?.servsubsid)}
                    </TableBodyItem>
                    <TableBodyItem>
                      {
                        reportReasonList?.find((r) => r.id === d?.reasonid)
                          ?.text
                      }
                    </TableBodyItem>
                    <TableBodyItem>
                      {dayjs(d?.time)?.format("YYYY-MM-DD HH:mm")}
                    </TableBodyItem>
                    <TableBodyItem>
                      {dayjs(d?.comptime)?.format("YYYY-MM-DD HH:mm")}
                    </TableBodyItem>
                    <TableBodyItem>
                      <LineBtn
                        btnText="보기"
                        btnClickEvent={() => {
                          setDetailData(d);
                          setReportDetailModal(true);
                        }}
                        disabled={!auth?.chat}
                      />
                    </TableBodyItem>
                  </TableBody>
                );
              }
            )}

            {reportDetailModal && (
              <ChatReportDetailModal
                closeEvent={() => setReportDetailModal(false)}
                data={detailData}
                isChatReportCompleteModal={true}
              />
            )}
          </>
        </Table>

        <Pagination
          totalPage={response?.status === 200 ? response.data.totalPage : 0}
          currentPage={page}
          pageClickEvent={(index) => setPage(index)}
          pageSize={response?.status === 200 ? +response?.data?.pageSize : 0}
        />
      </LineBox>

      {loading && <Loader />}
    </ChatSection>
  );
}
